import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import {style} from "variables/Variables.jsx";
import "../assets/css/datatables/datatables.min.css";
import "../assets/css/datatables/responsive.dataTables.min.css";
import SimpleReactValidator from "simple-react-validator";
import NotificationSystem from "react-notification-system";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import {confirmAlert} from 'react-confirm-alert';
import {FormGroup, Input, Label} from "reactstrap";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class ViewQuery extends Component{

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            queryData: [],
            loading:false,
            query: '',
            modelVersion: '',
            type: '',
            queryType: '',
            userGroup:'',
            isSubmit:false,
            userType: '',
            isNew: '',
            _notificationSystem: null,
            status: '',
            displayQrName: '',
            jsonBody: '',
            inputVersionName: '',
            queryArgs: '',
            values:[],
            apiResult:'',
            selectedOutputVersion:'',
            loadingApi:false,
            queryVersionTitle:'',
            queryTitle:'',
            userGroups:[],
            dataStores: []
        }

    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            userType:decoded.userType,
            userGroup:decoded.userGroup,
        });

        axios.get(config.get('API_URL')+'/sqlbuilder/getQuery/'+this.props.match.params.id).then(response => {
            let qrName;
            let displayQrName;
            console.log(response);
            let outputVersion;
            let queryTitle;
            let queryVersionTitle;
            var queyStr = JSON.parse(response.data[0].extraData).queryArgs;

            if(response.data[0].dataStore=='api-studio' || response.data[0].queryType=='noSQL')
            {
                 qrName = JSON.parse(response.data[0].extraData).defaultQuery;
            }
            else{
                 qrName = response.data[0].query;
            }
            if(response.data[0].dataStore=='api-studio' && response.data[0].queryType=='SQL'){
                displayQrName = JSON.parse(response.data[0].extraData).defaultQuery;
            }
            else{
                displayQrName = response.data[0].query;
            }
            var isNew = JSON.parse(response.data[0].extraData).isNewVersion;
            if(isNew===true){
                outputVersion = JSON.parse(response.data[0].extraData).newVersionName;
            }
            else{
                this._getOutputVersionName(response.data[0].outputVersion);
           }
            if(response.data[0].dataStore=='data-pipeline'){
                 queryTitle='Pipeline Name';
                 queryVersionTitle='Analytx Store Version';
            }
            else if(response.data[0].dataStore=='data-modeler') {
                queryTitle='Modeler Name';
                queryVersionTitle='Object Store Version'
            }
            else{
                queryTitle='Studio Name';
                queryVersionTitle='Api Store Version'
            }
             var jsonBody = '';
            // if(response.data[0].versionType=='api-studio' && response.data[0].queryType=='SQL') {
            //     jsonBody = ' {\n' +
            //         '\t"version": '+response.data[0].inputVersionData.name+',\n' +
            //         '\t"queryType": "sql",\n' +
            //         '\t"queryName": '+response.data[0].queryName+',\n' +
            //         '\t"args": {\n' +
            //         '\t\t"Source": " "\n' +
            //         '\t\t"Overdue": " "\n' +
            //         '\t\t\n' +
            //         '\t}\n' +
            //         '} ';
            // }
            this.setState({
                id: response.data[0].id,
                jsonBody: jsonBody,
                queryName: response.data[0].tableName,
                status: response.data[0].status,
                def_query: response.data[0].query,
                query:qrName,
                isNew: isNew,
                displayQrName: displayQrName,
                selectedVersion: response.data[0].inputVersion,
                output_version: outputVersion,
                versionType: response.data[0].dataStore,
                queryType: response.data[0].queryType,
                extraData: response.data[0].extraData,
                createdBy: response.data[0].createdBy,
                queryArgs: queyStr,
                queryVersionTitle: queryVersionTitle,
                queryTitle: queryTitle
            });
            this._getInputVersionName(response.data[0].inputVersion);
        });

        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;

        axios.get(config.get('API_URL')+'/users/allusergroups/',{

        }).then(response => {
            this.setState({
                userGroups:response.data
            })
        });
        this.findAccessKeys();
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }
    _getInputVersionName(value){
        axios.get(config.get('API_URL')+'/sqlbuilder/getVersionName/'+value).then(response => {
            this.setState({
                inputVersionName : response.data.name
            })
        });
    }
    _getOutputVersionName(value){
        axios.get(config.get('API_URL')+'/sqlbuilder/getVersionName/'+value).then(response => {
            this.setState({
                output_version : response.data.name
            })
        });
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    handleChange(i,e) { console.log(i);
        this.setState({
            values: {...this.state.values, [i]: e.target.value },
        });


    }
    toggleApiDetailsModel() {
        this.setState({
            saveQueryModel: !this.state.saveQueryModel
        })
    }


    onSubmit(e) {
        e.preventDefault();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            loading: true
        });
        //alert(this.state.query);
        if ($.fn.DataTable.isDataTable('#queryBuilderTable')) {
            $('#queryBuilderTable').DataTable().clear().destroy();
            $('#queryBuilderTable').html('');
        }
        const data = {
            query: this.state.query,
            modelVersion: this.state.selectedVersion,
            type: this.state.versionType,
            queryType: 'SQL',
            userGroup: decoded.userGroupName,
            rowLevelAccessKeys: this.state.dataStores
        };
        axios.post(config.get('API_URL')+'/sqlbuilder/sqlBuilder', data, {
            headers: {
                Authorization: ` ${token}`
            }
        })
            .then(response => {
                if (response.data.error) {
                    console.log("error");
                    this.setState({
                        errors: response.data.error
                    })
                } else {
                    console.log("sucessss");
                    console.log(response.data);
                    this.setState({
                        chartData :response.data.data,
                        isSubmit:true,
                        loading: true
                    });

                    const tableHeaders = [];
                    const exampleRecord = response.data.data[0];
                    const keys = Object.keys(exampleRecord);
                    console.log(keys);
                    keys.forEach(function(k) {
                        tableHeaders.push({
                            sTitle: k,
                            mData: k.replace(/\./g,'\\.')
                            //optionally do some type detection here for render function
                        });
                    });
                    console.log(tableHeaders);
                    //const header = tableHeaders
                    $('#queryBuilderTable').DataTable({
                        "bProcessing": true,
                        "aaData": response.data.data,
                        "aoColumns": tableHeaders,
                        responsive: true,
                        mark:true
                    });
                    this.setState({
                        loading: false
                    })

                }
            })
            .catch(err => {
                console.log(err);
            })
    }
    changeStatus(val){
    var st='';
    if(val=='Approved'){
        st = 'Approve';
    }
    else{
        st = 'Reject';
    }
        confirmAlert({
            title: 'Question',
            message: 'Are you sure you want to ' +st+ ' this Query?.',
            buttons: [{
                label: 'Yes',
                onClick: () => {
                    this.handleClickStatus(val);
                }
            },
                {
                    label: 'No',
                }
            ]
        });

    }
    handleClickStatus(val){
        this.setState({
            loading: true
        });
        if(this.state.versionType=='api-studio') {
           this._changeApiStatus(val);
        }
        else {
            this._changeStatus(val);
        }
        this.setState({
            loading: false
        })
    }

    _changeApiStatus(val){
        axios.put('/sqlbuilder/apiEditStatus', {
            id: this.state.id,
            status: val
        })
            .then(response => {
                console.log(response);
                if (this.state.isNew === true) {
                    const newVersionData = {
                        name: this.state.output_version,
                        type: this.state.versionType,
                        userID: this.state.createdBy,
                        queryID: this.state.id
                    };
                    axios.post(config.get('API_URL')+'/users/addversion/', newVersionData).then(response => {
                        console.log(response);
                        if (response.data.error) {
                            console.log(response.data.error);
                        } else {
                            console.log("added")
                        }
                    });
                }
                this.handleNotificationClick("tr", 1, "Query has been successfully "+response.data.status+'.');
                this.setState({
                    loading: false,
                    isSubmit: false
                });
                if ($.fn.DataTable.isDataTable('#queryBuilderTable')) {
                    $('#queryBuilderTable').DataTable().clear().destroy();
                    $('#queryBuilderTable').html('');
                }
            })
            .catch(error => {
                this.handleNotificationClick("tr", 3, "Error");
                console.log(error);
            });
    }
    _changeStatus(val){
        this.setState({
            loading: true
        });
        axios.put('/sqlbuilder/editStatus', {
            id: this.state.id,
            status: val,
            query: this.state.query,
            version: this.state.inputVersionName,
            isNew: this.state.isNew,
            output_version: this.state.output_version,
            queryName: this.state.queryName,
            versionType: this.state.versionType,
            extraData: this.state.extraData,
            queryType: this.state.queryType,
            createdBy: this.state.createdBy
        })
            .then(response => {
                console.log(response);
                if (response.data.code == 200) {
                    if (this.state.isNew === true) {
                        const newVersionData = {
                            name: this.state.output_version,
                            type: this.state.versionType,
                            userID: this.state.createdBy,
                            queryID: this.state.id
                        };
                        axios.post(config.get('API_URL')+'/users/addversion/', newVersionData).then(response => {
                            console.log(response);
                            if (response.data.error) {
                                console.log(response.data.error);
                            } else {
                                console.log("added")
                            }
                        });

                    }

                    axios.post(config.get('API_URL')+'/sqlbuilder/fetch_table_columns', {
                        queryName: this.state.queryName,
                        output_version: this.state.output_version,
                        type: this.state.versionType
                    })
                        .then(response => { console.log("cols"); console.log(response);
                            if (response.data.error) {
                                console.log("error");
                            } else {
                                console.log("sucessss");
                                console.log(response.data);
                                const newData = {
                                    table_id: this.state.id,
                                    user_type: this.state.userType,
                                    user_group: this.state.userGroup,
                                    col_data: response.data.data,
                                    all_groups: this.state.userGroups
                                };
                                axios.post(config.get('API_URL')+'/sqlbuilder/add_columns/', newData).then(response => {
                                    console.log("addcols");
                                    console.log(response);
                                    if (response.data.error) {
                                        console.log(response.data.error);
                                        this.handleNotificationClick("tr", 3, "Error");
                                        this.setState({
                                            loading: false,
                                            isSubmit: false
                                        })
                                    } else {
                                        //alert("added");
                                        this.handleNotificationClick("tr", 1, "Query has been successfully Approved.");
                                        this.setState({
                                            loading: false,
                                            isSubmit: false
                                        });
                                        if ($.fn.DataTable.isDataTable('#queryBuilderTable')) {
                                            $('#queryBuilderTable').DataTable().clear().destroy();
                                            $('#queryBuilderTable').html('');
                                        }
                                    }
                                });

                            }
                        })
                        .catch(err => {
                            console.log(err);
                            this.handleNotificationClick("tr", 3, "Error");
                            this.setState({
                                loading: false,
                                isSubmit: false
                            })

                        });
                }

            })
            .catch(error => {
                this.handleNotificationClick("tr", 3, "Error");
                this.setState({
                    loading: false,
                    isSubmit: false
                })
            });
    }
    apiCall(){
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const apiData = {
            version: this.state.output_version,
            //versionID: this.state.selectedVersion,
            queryType: this.state.queryType,
            queryName: this.state.queryName,
            args: this.state.values,
            userGroup: decoded.userGroupName,
            rowLevelAccessKeys: this.state.dataStores
        };
        this.setState({
            loadingApi: true
        });
        axios.post(config.get('API_URL')+'/sqlbuilder/viewApiQuery/', apiData,{
            headers: {
                Authorization: ` ${token}`
            }
        }).then(response => { console.log("abb");
            console.log(response);
            if (response.data.error || response.data.data == undefined) {
                //console.log(response.data.error);
                this.handleNotificationClick("tr", 3, "Error");
                this.setState({
                    loadingApi: false
                })
            } else {
                const tableHeaders = [];
                const apiRecord = response.data.data[0];
                const keys = Object.keys(apiRecord);
                console.log(keys);
                keys.forEach(function(k) {
                    tableHeaders.push({
                        sTitle: k,
                        mData: k.replace(/\./g,'\\.')
                        //optionally do some type detection here for render function
                    });
                });
                console.log(tableHeaders);
                //const header = tableHeaders
                $('#apiViewTable').DataTable({
                    "bProcessing": true,
                    "aaData": response.data.data,
                    "aoColumns": tableHeaders,
                    responsive: true,
                    mark:true
                });
                this.setState({
                    apiResult:response.data.data,
                    loadingApi: false
                })

            }
        });
    }
    findAccessKeys() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL')+'/users/user_access_keys/',{
            params: {
                userID: decoded._id
            }
        }).then(response => {
            // console.log("keys");
            // console.log(response.data);
            let dataStore =  { name: "", versions:"", tables:"", columns:"", value:"" };
            const newDataStores = response.data.map((keyData, index) => { console.log("keys"); console.log(keyData);

                return { ...dataStore, name:keyData.attrbData.tableData.versionData.dataStore, versions:keyData.attrbData.tableData.versionData.name, tables:keyData.attrbData.tableData.tableName,  value: keyData.value , columns: keyData.attrbData.attrName};
            });
            this.setState({ dataStores: newDataStores });

        });
    }
    render(){  console.log(this.state.dataStores);
        let tableIcons = null;
        let parameters = [];
        if(this.state.isSubmit === true && this.state.userType=='Admin'){
            tableIcons = (
                <React.Fragment>
                    {this.state.status!='Rejected' ? (
                        <a href="#" className="reject-query-icon" role="button"  onClick={this.changeStatus.bind(this,'Rejected')} >
                            <i className="fa fa-ban" aria-hidden="true"></i>Reject
                        </a>
                    ):null }
                    {this.state.status!='Approved' ? (
                        <a href="#" className="approve-query-icon" role="button"  onClick={this.changeStatus.bind(this,'Approved')} >
                            <i className="fa fa-check" aria-hidden="true"></i> Approve
                        </a>
                     ):null}
             </React.Fragment>
            );
        }
        if(this.state.versionType=='api-studio' && this.state.queryType=='SQL'){
            let args = this.state.queryArgs;
            Object.keys(args).forEach((k,index)  => {
                parameters.push (
                    <tr key={index+1}>
                        <th width="30%"><label>{args[k]}</label></th>
                        <td width="70%"><input type="text" value={this.state.values[index]} name={args[k]} onChange={this.handleChange.bind(this, args[k])} /></td>
                    </tr>
                );
            })
        }
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <div className="header query-builder">
                                    <h4 className="title">{this.state.queryName}</h4>
                                    <p className="category"></p>
                                </div>
                                <form className="" method="POST" onSubmit={this.onSubmit}>
                                    <div className="row tab-content">
                                        <div className="col-md-8 col-md-border-right">
                                            <form className="" method="POST" onSubmit={this.onSubmit}>
                                                <div className="padd15">
                                                    <div className="form-group">
                                        <textarea rows="3" name = "query" placeholder="select * from Test.test_table limit 10" id="formControlsTextarea"
                                                  className="form-control queyEditor" disabled="disabled"  value={this.state.displayQrName}></textarea>
                                                        {this.validator.message('query', this.state.query, 'required')}
                                                    </div>
                                                    {/*<button type="submit" className="btn btn-primary pull-right">Preview Result</button>*/}
                                                    <br/>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="padd15">
                                                <div className="save_editor_form">
                                                    <div className="col-md-12">
                                                        <FormGroup>
                                                            <Label for="queryName">{this.state.queryTitle}</Label>
                                                            <Input  name="queryName" id="queryName" value={this.state.queryName}  onChange={this.onChange} disabled="disabled"/>
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <FormGroup>
                                                            <Label for="Version">{this.state.queryVersionTitle}</Label>
                                                            <select name="version" className="form-control" value={this.state.output_version} disabled="disabled" >
                                                                <option>{this.state.output_version}</option>
                                                            </select>
                                                        </FormGroup>
                                                    </div>
                                                    { this.state.output_version=='new' ?
                                                        <div className="col-md-12">
                                                            <FormGroup>
                                                                <Label for="newVersion">New Version</Label>
                                                                <Input  name="newVersion" id="newVersion" value={this.state.newVersion}  onChange={this.onChange}/>
                                                            </FormGroup>
                                                        </div>
                                                        : null }
                                                </div>

                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>

                                    {  tableIcons }
                                    {/*{this.state.versionType == 'api-studio' && this.state.queryType == 'SQL' ?*/}
                                    {/*    <a href="#" className="btn btn-primary pull-right viewApiButton" role="button"  onClick={this.toggleApiDetailsModel.bind(this)} >*/}
                                    {/*        View Api Details*/}
                                    {/*    </a>*/}
                                    {/*    : null*/}

                                    <button type="submit" className="btn btn-primary pull-right">Preview Result</button>

                                    <div className="clearfix"></div>
                                </form>

                                <div className='sweet-loading'>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </div>

                                <div className="content table-full-width table-responsive">
                                    <table className="table table-striped table-hover" id="queryBuilderTable">
                                    </table>
                                </div>
                                {this.state.versionType=='api-studio' && this.state.queryType=='SQL' ?
                                <div className="apiView">
                                    <div className="view-panel">
                                        <div className="col-md-6">
                                            <div className="apiUrl">
                                                <span className="postButton">POST</span>
                                                <span>http://192.168.201.90/sqlbuilder/viewApiQuery</span>
                                            </div>
                                            <h4>Parameters</h4>
                                            <table width="100%" border="0px">
                                                <tbody>
                                                    <tr>
                                                        <th width="30%">Version</th>
                                                        <th width="70%">{this.state.output_version}</th>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Query Type</th>
                                                        <th width="70%">SQL</th>
                                                    </tr>
                                                    <tr>
                                                        <th width="30%">Query Name</th>
                                                        <th width="70%">{this.state.queryName}</th>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                    <tr className="pramsHeader">
                                                        <th width="30%">Query Args</th>
                                                        <th width="70%">Value</th>
                                                    </tr>
                                                    {parameters}
                                                </tbody>
                                            </table>
                                            <button type="submit" onClick={this.apiCall.bind(this)} className="btn btn-primary pull-right">Try it out

                                            </button>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="col-md-12">
                                                {/*<Label for="queryName">HTTP POST to this URL</Label>*/}
                                                {/*<Input  name="queryName" id="queryName" value="http://localhost:4000/sqlbuilder/viewApiQuery" />*/}
                                                <Label for="queryName">Result JSON Schema</Label>

                                                <textarea rows="13" name = "bodySchema" onChange={this.onChange}
                                                          className="form-control" value={JSON.stringify( this.state.apiResult , undefined, 2)}></textarea>
                                            </div>

                                            <div className="clearfix"></div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                                    : null }
                            </div><br/>
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loadingApi}
                                />
                            </div>
                            <div className="content table-full-width table-responsive">
                                <table className="table table-striped table-hover" id="apiViewTable">
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default ViewQuery;